/**
 * MESSAGE TOKENS
 * Source: 🎨 Figma — components-rentals export
 *
 * Custom additions are marked with "Custom" comments below.
 */

import { type SemanticTokens, SEMANTIC } from '../semantic.js';

export function createMessageTokens(s: SemanticTokens) {
  return {
  // ──── Figma tokens ────

  /** Base spacing and typography for messages */
  base: {
    paddingX: s.layout.gap.md,            // --messages-base-padding-x: var(--spacing-16)
    paddingY: s.layout.gap.md,            // --messages-base-padding-y: var(--spacing-16)
    gap: s.layout.gap.sm,                 // --messages-base-gap: var(--spacing-8)
    radius: s.radius.md,                  // --messages-base-radius: var(--radius-8)

    // ── Custom base additions ──
    textGap: s.layout.gap.xs,             // --messages-base-text-gap: var(--spacing-4) — gap between title and body
    width: '20rem',                       // --messages-base-width: 320px
    transitionDuration: '0.3s',           // --messages-base-transition-duration
    blur: '0',                            // --messages-base-blur: no backdrop blur
    titleFontSize: s.typography.fontSize.lg,         // --text-size-lg: 1.125rem (18px)
    titleFontWeight: s.typography.fontWeight.semibold, // --font-weight-semibold: 600
    bodyFontSize: s.typography.fontSize.base,        // --text-size-base: 1rem (16px)
    bodyFontWeight: s.typography.fontWeight.normal,  // --font-weight-normal: 400
    closeButtonSize: s.layout.gap.xl,                // --messages-close-button-size: 2rem (32px)
    closeButtonRadius: '50%',             // --messages-close-button-radius: circular
    closeIconSize: s.typography.fontSize.base,       // --messages-close-icon-size: 1rem (16px)
    shadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.15)', // --messages-base-shadow
    fontFamily: s.typography.fontFamily.base,  // --messages-base-font-family
    borderWidth: '1px',                       // --messages-base-border-width
    iconSize: s.iconSizes.lg,                 // --messages-base-icon-size
    toastIconSize: s.iconSizes.md,            // --messages-base-toast-icon-size
    toastBorderWidth: '0 0 0 4px',            // --messages-base-toast-border-width
    summaryFontWeight: s.typography.fontWeight.semibold, // --messages-base-summary-font-weight
    summaryLineHeight: s.typography.lineHeight['2xl'], // --messages-base-summary-line-height
    iconMarginTop: '0.25rem',                  // --messages-base-icon-margin-top
  },
  success: {
    bg: s.states.success.bg,                 // --messages-success-bg: var(--states-success-bg)
    fg: s.states.success.fg,                 // --messages-success-fg: var(--states-success-fg)
    border: s.states.success.border,         // --messages-success-border: var(--states-success-border)
  },
  danger: {
    bg: s.states.danger.bg,                  // --messages-error-bg: var(--states-danger-bg)
    fg: s.states.danger.fg,                  // --messages-error-fg: var(--states-danger-fg)
    border: s.states.danger.border,          // --messages-error-border: var(--states-danger-border)
  },
  warning: {
    bg: s.states.warning.bg,                 // --messages-warning-bg: var(--states-warning-bg)
    fg: s.states.warning.fg,                 // --messages-warning-fg: var(--states-warning-fg)
    border: s.states.warning.border,         // --messages-warning-border: var(--states-warning-border)
  },
  info: {
    bg: s.surface.ground,                    // --messages-neutral-info-bg: var(--color-neutral-white)
    fg: s.border.secondary,                  // --messages-neutral-info-fg: var(--color-rentsody-800)
    border: s.border.secondary,              // --messages-neutral-info-border: var(--color-rentsody-800)
  },

  // ──── Custom tokens (not in Figma) ────

  secondary: {
    bg: s.surface.ground,                    // --messages-secondary-bg: var(--surface-ground)
    fg: s.text.secondary,                    // --messages-secondary-fg: var(--text-secondary)
    border: s.border.secondary,              // --messages-secondary-border: var(--border-secondary)
  },
  };
}
export const messageTokens = createMessageTokens(SEMANTIC);